import { Icon } from '@/components/Icons';
import { ManagerTableCellLabel as Label } from '../ManagerTableCellLabel';
import { ManagerTableLinkButton as LinkButton } from '../ManagerTableLinkButton';

interface ManagerTableUnlockButtonProps {
  /** Additional CSS classes */
  className?: string;
  /** Whether the item is locked or unlocked */
  isLocked: boolean;
  /** Click handler for the button */
  onClick?: () => void;
}

/**
 * ManagerTableUnlockButton Component
 *
 * This component renders a button that indicates whether a certain item
 * (e.g., a certification or user profile) is locked or unlocked. If it's locked,
 * it shows an "Unlock" button with a lock icon. If it's unlocked, it displays
 * a checkmark icon and an "Unlocked!" label. The button can be styled with
 * additional CSS classes and can trigger an optional click handler when the
 * unlock action is performed.
 */
export const ManagerTableUnlockButton: React.FC<ManagerTableUnlockButtonProps> = ({
  className,
  isLocked,
  onClick,
  ...props
}) => {
  return isLocked ? (
    <LinkButton
      className="-mt-[1px] text-neutral-black"
      label="Unlock"
      icon="Lock"
      onClick={onClick}
    />
  ) : (
    <div className="-mt-[1px] flex items-center gap-1">
      <Icon name="CheckCircle" size={16} />
      <Label label="Unlocked!" />
    </div>
  );
};

ManagerTableUnlockButton.displayName = 'ManagerTableUnlockButton';

export default ManagerTableUnlockButton;
